import AiAgentToolsAPI from 'dashboard/api/aiAgents/tools';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

// Shared tool catalog (D12). update/delete re-throw raw errors so the UI can
// run the 409 dependent-agents confirm flow ({ error, dependent_agents }) and
// re-submit with changeConfirmed: true.
export default createStore({
  name: 'AiAgentTool',
  API: AiAgentToolsAPI,
  actions: mutations => ({
    get: async ({ commit }) => {
      commit(mutations.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await AiAgentToolsAPI.get();
        commit(mutations.SET, response.data.payload);
        return response.data.payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
      }
    },
    update: async ({ commit }, { id, changeConfirmed, ...toolAttributes }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await AiAgentToolsAPI.update(id, toolAttributes, {
          changeConfirmed,
        });
        commit(mutations.EDIT, response.data);
        return response.data;
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
    delete: async ({ commit }, { id, changeConfirmed }) => {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await AiAgentToolsAPI.delete(id, { changeConfirmed });
        commit(mutations.DELETE, id);
        return id;
      } finally {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
      }
    },
  }),
});
